<template>
  <button
    type="button"
    :class="$style.button"
    :aria-label="`${isPlaying ? 'Pause' : 'Play'}`"
    @click.prevent="$emit('audioAction', $event)"
    @keypress.prevent="$emit('audioAction', $event)"
  >
    <span :class="$style.track">
      <span :class="$style.icon">
        <component
          :is="isPlaying && isActive(index) ? IconPauseCircle : IconPlayCircle"
          :key="isPlaying && isActive(index) ? 'pause' : 'play'"
          :class="$style.playPause"
          role="img"
        ></component>
      </span>
      <span :class="$style.counter">
        <span>{{ index + 1 }}.</span>
      </span>
      <span :class="$style.playlistTitle" v-html="title"></span>
    </span>
    <span :class="$style.duration">{{ formatDuration(duration) }}</span>
  </button>
</template>

<script setup lang="ts">
import { formatDuration } from '@/utils';
import IconPauseCircle from '@/assets/svgs/IconPauseCircle.svg?component';
import IconPlayCircle from '@/assets/svgs/IconPlayCircle.svg?component';
import { storeToRefs } from 'pinia';
import { useAudioStore } from '@/stores/audioStore';

const props = defineProps<{
  duration: string;
  id: number;
  index: number;
  title: string;
}>();

defineEmits({
  audioAction: null,
});

const store = useAudioStore();
const { audioId, currentTrack, isPlaying } = storeToRefs(store);

function isActive(index: number): boolean {
  return audioId && currentTrack && audioId.value === props.id && currentTrack.value === index;
}
</script>

<style lang="scss" module>
.button {
  align-items: center;
  cursor: pointer;
  display: flex;
  justify-content: space-between;
  padding: 1rem 0;
  width: 100%;

  &:focus {
    background-color: $black;
    color: $white;

    .icon {
      svg {
        fill: $white;
      }
    }
  }
}
.counter {
  flex-shrink: 0;
  margin-left: 0.75rem;
  width: px-to-rem(20);

  span {
    float: right;
  }
}
.duration {
  margin-left: 1rem;
}
.icon {
  cursor: pointer;
  height: 1.5rem;
}
.play-pause {
  align-self: center;
  cursor: pointer;
  fill: $black;
  height: 1.5rem;
  width: 1.5rem;
}
.playlist-title {
  cursor: pointer;
  margin-left: 1rem;
  text-align: initial;
  word-break: break-word;
}
.track {
  align-items: center;
  display: flex;
}
</style>
